import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const RtfIcon = ({ color = '#55a9ef', text = 'RTF' }) => (
  <BaseFileIcon color={color} text={text} />
);

export default RtfIcon;
